import { render, staticRenderFns } from "./GlobalSearchSkeletonCard.vue?vue&type=template&id=2c1a46ba&scoped=true"
import script from "./GlobalSearchSkeletonCard.vue?vue&type=script&lang=js"
export * from "./GlobalSearchSkeletonCard.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearchSkeletonCard.vue?vue&type=style&index=0&id=2c1a46ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a46ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1a46ba')) {
      api.createRecord('2c1a46ba', component.options)
    } else {
      api.reload('2c1a46ba', component.options)
    }
    module.hot.accept("./GlobalSearchSkeletonCard.vue?vue&type=template&id=2c1a46ba&scoped=true", function () {
      api.rerender('2c1a46ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GobalSearch/GlobalSearchSkeletonCard.vue"
export default component.exports